import axios from "axios";
import { API_BASE_URL } from "../utils/config";

const getAuthorizationHeader = () => {
  const token = localStorage.getItem("consumerSite_token");
  return token ? `Bearer ${token}` : "";
};

const getPartnerSiteHeaders = () => {
  const partnerSiteId = JSON.parse(sessionStorage.getItem("partnerSiteId"));
  return {
    "x-partner-id": partnerSiteId?.uid ?? 0,
    "x-site-id": partnerSiteId?.siteId ?? 0,
  };
};
export const contactUs = async (payload) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/contact/v1/contact-us`,
      payload,
      {
        headers: {
          Authorization: getAuthorizationHeader(),
          ...getPartnerSiteHeaders(),
        },
      }
      // {
      //   headers: {
      //     "X-CSRF-TOKEN": token,
      //   },
      // }
    );
    return { 
      response: {
        data: response.data,
        status: response.status,
        statusText: response.statusText
      }, 
      API_Name: "contactUs" 
    };
  } catch (error) {
    throw error.response?.data || error.message || error;
  }
};
export const affiliate = async (payload) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/contact/v1/affiliate`,
      payload,
      {
        headers: {
          Authorization: getAuthorizationHeader(),
          ...getPartnerSiteHeaders(),
        },
      }
    );
    return { 
      response: {
        data: response.data,
        status: response.status,
        statusText: response.statusText
      }, 
      API_Name: "affiliate" 
    };
  } catch (error) {
    throw error.response?.data || error.message || error;
  }
};
